import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

interface Props {
  htmlId?: string;
  className?: string;
  icon: IconProp;
  disabled?: boolean;
  onClick?: () => void;
}

const RoundButton: React.FC<Props> = ({ htmlId, className, icon, onClick, disabled }) => (
  <div
    id={htmlId}
    role="presentation"
    className={`round-button ${className} ${disabled ? 'disabled' : ''}`}
    onClick={onClick}
  >
    <FontAwesomeIcon icon={icon} />
  </div>
);

export default RoundButton;
